import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-200/50 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 py-10 md:py-14">
          <div className="md:col-span-1">
            <Link to="/" className="inline-block">
              <span className="text-2xl font-heading font-bold text-primary-600">老色哥</span>
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              成熟男士的穿搭圣经<br />品味男人的生活方式
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:text-primary-600 hover:bg-primary-100/50 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:text-primary-600 hover:bg-primary-100/50 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:text-primary-600 hover:bg-primary-100/50 transition-colors" aria-label="小红书">
                <i className="ri-red-packet-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">热门文章</h4>
            <ul className="space-y-2.5">
              <li><Link to="/article/shenshi-zhuangban-xuanze-zhinan" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200">西装选择完全指南</Link></li>
              <li><Link to="/article/fugu-nanzhuang-fanrong-qushi" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200">秋冬复古男装趋势</Link></li>
              <li><Link to="/article/nanshi-shoubiao-xuanze-jiqiao" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200">手表选择指南</Link></li>
              <li><Link to="/article/weishiji-pinjian-ru-men" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200">威士忌品鉴入门</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200">品牌介绍</Link></li>
              <li><a href="mailto:contact@laosege.com" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200">商务合作</a></li>
              <li><a href="#" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200">隐私政策</a></li>
              <li><a href="#" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200">用户协议</a></li>
            </ul>
            <p className="mt-4 text-xs text-foreground-500">
              联系邮箱：contact@laosege.com<br />
              电话：021-6288-8888
            </p>
          </div>
        </div>

        <div className="border-t border-background-200/70 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-foreground-500">
            &copy; 2026 老色哥 laosege.com 版权所有
          </p>
          <p className="text-xs text-foreground-500">
            沪ICP备2024XXXXXXXX号-1
          </p>
        </div>
      </div>
    </footer>
  );
}